// 导入组件
import searchTree from './src/zTree.vue'

// 为组件提供 install 安装方法，供按需引入
searchTree.install = function (Vue) {
  Vue.component(searchTree.name, searchTree)
}

// 默认导出组件
export default searchTree
